"use client";

import { c as _c } from "react/compiler-runtime";
import { LazyMotion, MotionConfig, domAnimation } from "motion/react";
import { NuqsAdapter } from "nuqs/adapters/next/app";
import type { PropsWithChildren } from "react";
import { ToastProvider } from "@/components/application/toast/ToastProvider";
import { AnalysisSidebarProvider } from "@/providers/analysis-sidebar-provider";
import { AuthProvider } from "@/providers/auth";
import { DebugSettingsProvider } from "@/providers/debug-settings";
import { QueryProvider } from "@/providers/query-provider";
import { RouteProvider } from "@/providers/router-provider";
import { Theme } from "@/providers/theme";
export function Providers(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <MotionConfig reducedMotion="user"><LazyMotion features={domAnimation} strict={true}><QueryProvider><NuqsAdapter><RouteProvider><AnalysisSidebarProvider><Theme><DebugSettingsProvider><AuthProvider><ToastProvider>{children}</ToastProvider></AuthProvider></DebugSettingsProvider></Theme></AnalysisSidebarProvider></RouteProvider></NuqsAdapter></QueryProvider></LazyMotion></MotionConfig>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}